var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDashboardBuilderIcon = function SvgDashboardBuilderIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3aacc8"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m20 9 2.6 1.51-.91 1.58-1.69-.98-1.69.98-.91-1.58zm-6.9 3.99.91 1.59-1.69.97v1.96H10.5V14.5zm13.79 0 2.6 1.5v3.02h-1.82v-1.96l-1.69-.98zm-16.4 9.5h1.83v1.95l1.69.98-.92 1.59-2.6-1.51zm19 0v3.01l-2.6 1.51-.92-1.58 1.69-.98v-1.96zm-12.1 7.01.91-1.59 1.69.98 1.69-.98.92 1.59-2.61 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.96 18.95 1.82-1.04v8.37l-.91.52-.91-.52zM23.91 15.55l-1.82-1.04v10.98l1.82-1.04zM15.83 21.83l1.82-1.05v4.71l-1.82-1.04z"
  }))));
};
export { SvgDashboardBuilderIcon as ReactComponent };
export default __webpack_public_path__ + "d2a4c473fa542f74697ac7e9c25e78d6.svg";